import { html } from "lit";
import { ContentTeaserTemplate } from "../../partial-templates/teaser/content/content.templates";

export const NewsroomClientMagazineTemplate = () => {
    return html`
        <div
            class="ux-row ux-u-mx-zero ux-u-flex-jc-center ux-u-margin-vertical-40 ux-u-margin-l-vertical-50 ux-u-margin-xl-vertical-60"
        >
            <div class="ux-col-12 ux-col-sm-10">
                ${ContentTeaserTemplate({
                    segmentation: "1-1",
                    row: false,
                })}
            </div>
        </div>
    `;
};
